import { put, call } from "redux-saga/effects";
import { toast } from "react-toastify";
import { api } from "../../Config/ApiInterface";
import {
    fetchroomAvailabilitySuccess, fetchroomAvailabilityFailure
    , fetchroomSuccess, fetchroomFailure, fetchroomReservationsSuccess, fetchroomReservationsFailure,
    roomNumberDetailSuccess,
    roomNumberDetailFailure
} from "../../Actions";
import qs from "qs"; 

const getErrorMessage = (error, fallback) => {
    return error?.response?.data?.message || fallback;
};

function* fetchroomSaga(action) {
    try {
        const hotel_id=localStorage.getItem('hotel_id')
        const queryString = qs.stringify(action.payload);
        const response = yield call(api.post, `/room/rooms?hotel_id=${hotel_id}&${queryString}`);
        yield put(fetchroomSuccess(response.data));
    } catch (error) {
        const message = getErrorMessage(error, "Failed to fetch rooms.");
        yield put(fetchroomFailure(message));
        toast.error(message);
    }
}


function* fetchroomAvailabilitySaga(action) {
    try {
        const response = yield call(api.post, `/room/room-availability`, action.payload);
        yield put(fetchroomAvailabilitySuccess(response.data));
        // toast.success(response?.data?.message);
    } catch (error) {
        const message = getErrorMessage(error, "Failed to update room reservation.");
        yield put(fetchroomAvailabilityFailure(message));
        toast.error(message);
    }
}
function* fetchroomReservationsSaga(action) {
    try {
        const { start, end, booking_status } = action.payload || {};
        const response = yield call(api.get, '/reservation/reservations', {
            params: { start, end, booking_status },
        });
        yield put(fetchroomReservationsSuccess(response.data));
    } catch (error) {
        console.error('Fetch reservations error:', error?.response?.data || error.message);

        yield put(fetchroomReservationsFailure(error));

        const message =
            error?.response?.data?.message ||
            error?.message ||
            'Something went wrong while fetching reservations.';
        toast.error(message);
    }
}

function* roomNumberDetailSaga(action) {
    try {
        const { id } = action.payload || {};
        const response = yield call(api.post, `/room/room-detail/${id}`);
        yield put(roomNumberDetailSuccess(response.data));
    } catch (error) {
        console.error('Fetch reservations error:', error?.response?.data || error.message);
        yield put(roomNumberDetailFailure(error));
        const message =
            error?.response?.data?.message ||
            error?.message ||
            'Something went wrong while fetching reservations.';
        toast.error(message);
    }
}

export { fetchroomAvailabilitySaga, fetchroomReservationsSaga, fetchroomSaga,roomNumberDetailSaga }